import React from "react";

function Footer() {
	return (
		<footer className="sticky-footer" style={{backgroundColor:"#303030", color:"#ffffff"}}>
			<div className="container my-auto">
				<div className="copyright text-center my-auto">
					<span>
						COPYRIGHT &copy; 2022 by hiball. ALL RIGHTS RESERVED.
					</span>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
